import React, { useEffect, useState } from 'react';
import api from '../services/api';

const ESTILO = {
  info: 'bg-blue-100 text-blue-900 border-blue-300 dark:bg-blue-900/40 dark:text-blue-100 dark:border-blue-700',
  success: 'bg-emerald-100 text-emerald-900 border-emerald-300 dark:bg-emerald-900/40 dark:text-emerald-100 dark:border-emerald-700',
  warning: 'bg-amber-100 text-amber-950 border-amber-300 dark:bg-amber-900/40 dark:text-amber-100 dark:border-amber-700',
  error: 'bg-red-100 text-red-900 border-red-300 dark:bg-red-900/40 dark:text-red-100 dark:border-red-700',
};
const CLAVE = 'banner_global_cerrado';

// Aviso global que el administrador activa en Admin → Configuración.
// Se puede cerrar; vuelve a aparecer si el mensaje cambia.
export default function BannerGlobal() {
  const [banner, setBanner] = useState(null);
  const [cerrado, setCerrado] = useState('');

  useEffect(() => {
    let vivo = true;
    try { setCerrado(sessionStorage.getItem(CLAVE) || ''); } catch { /* sin storage */ }
    api.get('/config-publica', { skipAuthRedirect: true })
      .then(res => { if (vivo) setBanner(res.data?.banner || null); })
      .catch(() => { if (vivo) setBanner(null); });
    return () => { vivo = false; };
  }, []);

  if (!banner || cerrado === banner.mensaje) return null;

  const cerrar = () => {
    setCerrado(banner.mensaje);
    try { sessionStorage.setItem(CLAVE, banner.mensaje); } catch { /* sin storage */ }
  };

  return (
    <div role="status" className={`border-b text-sm px-4 py-2 flex items-center justify-center gap-3 ${ESTILO[banner.tipo] || ESTILO.info}`}>
      <span className="font-medium text-center">{banner.mensaje}</span>
      <button type="button" onClick={cerrar} aria-label="Cerrar aviso"
        className="shrink-0 grid place-items-center w-8 h-8 -my-1 rounded-lg hover:bg-black/10 dark:hover:bg-white/10 focus:outline-none focus-visible:ring-2 focus-visible:ring-current">
        <svg viewBox="0 0 24 24" className="w-4 h-4" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18" /></svg>
      </button>
    </div>
  );
}
